import styled, { css } from "styled-components";
import { cssIf } from "../../../utils/styledMixins";

const hasClickHandler = ({ onClick }) => !!onClick;

export const Label = styled.label(({ theme }) => css`
  display: block;
  margin-bottom: 10px;
  font-size: 16px;

  .is-active.checkbox-title {
    color: ${theme.palette.status.good};
    font-weight: ${theme.fonts.headingWeight};
  }
  
  ${cssIf(hasClickHandler)`
    cursor: pointer;
    user-select: none;
  `}
`);